import { render, staticRenderFns } from "./Sm600Error.vue?vue&type=template&id=38f7f8e2&scoped=true&"
var script = {}
import style0 from "./Sm600Error.vue?vue&type=style&index=0&id=38f7f8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7f8e2",
  null
  
)

export default component.exports